import { render, staticRenderFns } from "./DotsSixVertical.vue?vue&type=template&id=9258627a"
import script from "./DotsSixVertical.vue?vue&type=script&lang=js"
export * from "./DotsSixVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports